import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-decline",
  "use": "icon-decline-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol viewBox=\"0 0 20 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-decline\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-6h24v24H-2z\" /><path fill=\"#ED6F6F\" fill-rule=\"nonzero\" d=\"M14 12l2.29-2.29-4.88-4.88-4 4L0 1.41 1.41 0l6 6 4-4 6.3 6.29L20 6v6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol